import React, { useState } from 'react';
import { OnPitchLogo } from '../components/OnPitchLogo';

interface Props {
  onLogin: (email: string, password: string) => Promise<string | null>;
}

export function LoginPage({ onLogin }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) { setError('Remplis tous les champs'); return; }
    setLoading(true);
    setError('');
    const err = await onLogin(email, password);
    if (err) setError(err);
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-orb" />
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
          <OnPitchLogo height={36} variant="dark" />
        </div>
        <p className="login-subtitle">Back-office Admin</p>

        <input
          className="login-input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          autoComplete="email"
          autoFocus
        />
        <input
          className="login-input"
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
        />

        <button className="login-btn" type="submit" disabled={loading}>
          {loading ? 'Connexion...' : 'Se connecter'}
        </button>

        {error && <p className="login-error">{error}</p>}
      </form>
    </div>
  );
}
